import axios from 'axios';
import store from '../store';
import verifyAuth from '../services/utilities'

class MetaTraderCredentialsRepository {

    constructor() { /* noop */ }

    get basePath() {
        const backend = store.state.backend;
        if (!backend) throw new Error('Backend URL is not configured in store');
        return backend;
    }

    get tokenFromQuery() {
        if (typeof window === 'undefined') return null;
        return new URLSearchParams(window.location.search).get('token');
    }

    updateCredentials(metaTraderCredentials) {
        // eslint-disable-next-line no-console
        console.log('updateCredentials called, this context:', this);
        let headers = { 'Authorization': store.state.token };
        let response = axios.put(`${this.basePath}/metatrader-credentials`, metaTraderCredentials, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    getCredentialsById(metaTraderCredentialsId) {
        let headers = { 'Authorization': store.state.token };
        let response = axios.get(`${this.basePath}/metatrader-credentials/${metaTraderCredentialsId}`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    getCredentialsByBrokerAccountId(brokerAccountId) {
        let headers = { 'Authorization': store.state.token };
        let response = axios.get(`${this.basePath}/metatrader-credentials/broker-account/${brokerAccountId}`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    deleteCredentials(metaTraderCredentialsId) {
        let headers = { 'Authorization': store.state.token };
        let response = axios.delete(`${this.basePath}/metatrader-credentials/${metaTraderCredentialsId}`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    createCredentials(metaTraderCredentials) {
        // eslint-disable-next-line no-console
        console.log('createCredentials called, this context:', this);
        // eslint-disable-next-line no-console
        console.log('createCredentials payload:', metaTraderCredentials);
        try {
            const fallback = this.tokenFromQuery ? `Bearer ${this.tokenFromQuery}` : null;
            const headers = { Authorization: store.state.token || fallback };
            let response = axios.post(`${this.basePath}/metatrader-credentials`, metaTraderCredentials, { headers: headers });
            response = verifyAuth(response)
            return response;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error in createCredentials:', error);
            throw error;
        }
    }

    createCredentialsMT5(metaTraderCredentials) {
        // eslint-disable-next-line no-console
        console.log('createCredentialsMT5 called, this context:', this);
        // eslint-disable-next-line no-console
        console.log('createCredentialsMT5 payload:', metaTraderCredentials);
        try {
            const fallback = this.tokenFromQuery ? `Bearer ${this.tokenFromQuery}` : null;
            const headers = { Authorization: store.state.token || fallback };
            let response = axios.post(`${this.basePath}/metatrader-credentials-mt5-sync`, metaTraderCredentials, { headers: headers });
            response = verifyAuth(response)
            return response;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error in createCredentialsMT5:', error);
            throw error;
        }
    }

    createCredentialsFromPartner(metatraderCredentialsFromPartner) {
        let headers = { 'Authorization': store.state.token };
        let response = axios.post(`${this.basePath}/metatrader-credentials/from-partner`, metatraderCredentialsFromPartner, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    updateAllTradesForMetaTraderCredential(metaTraderCredentials) {
        let headers = { 'Authorization': store.state.token };
        let response = axios.post(`${this.basePath}/metatrader-credentials/update-all-trades`, metaTraderCredentials, { headers: headers });
        response = verifyAuth(response)
        return response;
    }
}

export default new MetaTraderCredentialsRepository();
